import { Fragment } from 'react';
import { isIOSNative } from 'utils/deviceUtils';

interface Props {
  additionalConditional?: boolean;
  children: JSX.Element;
}

const HideFromIOSNativeApp: React.FunctionComponent<Props> = ({
  additionalConditional = true,
  children,
}) => {
  return isIOSNative() && additionalConditional ? <Fragment /> : children;
};

export default HideFromIOSNativeApp;
